import React, { useEffect } from "react";
import { Box, Button, Typography, Grid, Card, CardMedia } from "@mui/material";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

const AboutUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      easing: "ease-in-out", // Animation easing
    });
  }, []);

  const navigate = useNavigate();

  const handleViewMoreClick = () => {
    navigate('/aboutus'); // Ensure this route exists in your router
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 4,
        padding: 7,
        position: "relative",
      }}
    >
      {/* Text Section */}
      <Box
        sx={{ flex: 1 }}
        data-aos="fade-up"
      >
        <Typography
          variant="h4"
          sx={{
            color: "#6A983C",
            fontWeight: "bold",
            mb: 2,
            fontFamily: '"Montserrat", sans-serif',  
          }}
        >
          About Us
        </Typography>

        <Typography variant="h6" sx={{ color: "#6A983C", mb: 2 }}>
          An Advanced Trading Company Capturing The Needs of the Moment
        </Typography>
        <Typography variant="body1" sx={{ color: "#98AF41", mb: 4 }}>
          We are a CGL Holding Company, which is GCC-based Investment Company having roots
          predominantly in trading and distribution in Dubai and all over UAE. Since its founding
          2 Decades ago in UAE, CGL GENERAL TRADING LLC has become the leading distributor of
          food and non-food products all over UAE. With our head office situated in Dubai, we have
          expanded our horizons progressively, diversifying into other sectors as well. We streamlined
          our operations bringing all businesses under the umbrella of CGL Holdings. This helped us in
          increasing our productivity, quality, and customer satisfaction tenfold.
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#6A983C",
            "&:hover": { backgroundColor: "#4A7627" },
            padding: "10px 20px",
            borderRadius: "20px",
            boxShadow: 2,
          }}
          onClick={handleViewMoreClick}
        >
          View More
        </Button>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "stretch",
          gap: 2,
          position: "relative",
          flexWrap: "nowrap",
        }}
        data-aos="fade-up"
      >
        {/* Left Image Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            width: "50%",
            height: { xs: "240px", md: "300px" }, // Ensure the height matches the right section
          }}
        >
          <Card
            sx={{
              width: "100%",
              height: "80%", // Takes up most of the height
              borderRadius: "18px",
              boxShadow: 3,
            }}
          >
            <CardMedia
              component="img"
              image="https://i.postimg.cc/Qtw1k6S8/smm10-45.webp"
              alt="Left Image"
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: "18px",
                objectFit: "cover",
              }}
            />
          </Card>
          {/* Experience Badge */}
          <Box
            sx={{
              width: "100%",
              height: "20%", // Ensures the badge fills the remaining height
              backgroundColor: "#6A983C",
              color: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "18px",
              fontSize: { xs: "12px", sm: "14px" },
              fontWeight: "bold",
              boxShadow: 2,
              mt: 1,
              textAlign:"center"
            }}
          >
            5+ Years Of Experience
          </Box>
        </Box>

        {/* Right Image Section */}
        <Box
          sx={{
            width: "50%",
            height: { xs: "240px", md: "300px" }, // Matches the height of the left section
          }}
        >
          <Card
            sx={{
              width: "100%",
              height: "100%",
              borderRadius: "18px",
              boxShadow: 3,
            }}
          >
            <CardMedia
              component="img"
              image="https://i.postimg.cc/9FYjnbN1/smm10-44.png"
              alt="Right Image"
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: "18px",
                objectFit: "cover",
              }}
            />
          </Card>
        </Box>
      </Box>






    </Box>
  );
};

export default AboutUs;
